import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Route } from 'react-router-dom'
import I18n from 'i18n-react'
import ReactGA from 'react-ga'

import packageJson from '../../package.json'

// translations
import csLanguage from '../Translations/cs.json'

// containers
import CustomerFormContainer from './CustomerFormContainer'
import PropertyContainer from './PropertyContainer'
import HouseholdContainer from './HouseholdContainer'
import HouseholdDetailContainer from './HouseholdDetailContainer'
import InitContainer from './InitContainer'
import LiabilityContainer from './LiabilityContainer'
import LiabilityDetailContainer from './LiabilityDetailContainer'
import PropertyTypeContainer from './PropertyTypeContainer'
import CalculateContainer from './CalculateContainer'

// components
import Loader from '../Components/Loader'
import NavigationPanel from '../Components/_ui/NavigationPanel'
import DomexButton from '../Components/_ui/DomexButton'
import Modal from '../Components/Modal'

// redux
import NavigationActions, {
  SCREENS, SCREEN_VALIDATE, getNavigationSteps, getActiveScreens, WEB_TYPES
} from '../Redux/NavigationRedux'
import { MOBILE_NAV, DESKTOP_NAV, ROUTE_ORDER } from '../routes/index'
import DomexActions from '../Redux/DomexRedux'
import GeneralActions from '../Redux/GeneralRedux'

const ROUTES = [{
  screen: SCREENS.INIT,
  component: InitContainer
}, {
  screen: SCREENS.PROPERTY_TYPE,
  component: PropertyTypeContainer
}, {
  screen: SCREENS.PROPERTY,
  component: PropertyContainer
}, {
  screen: SCREENS.HOUSEHOLD,
  component: HouseholdContainer
}, {
  screen: SCREENS.HOUSEHOLD_DETAIL,
  component: HouseholdDetailContainer
}, {
  screen: SCREENS.LIABILITY,
  component: LiabilityContainer
}, {
  screen: SCREENS.LIABILITY_DETAIL,
  component: LiabilityDetailContainer
}, {
  screen: SCREENS.CUSTOMER_FORM,
  component: CustomerFormContainer
}, {
  screen: SCREENS.FINAL,
  component: CalculateContainer
}]

class RootScreen extends React.Component {
  static propTypes = {
    domexGetParamsRequest: PropTypes.func.isRequired,
    domexSetDefaultForWebType: PropTypes.func.isRequired,
    error: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    insurance: PropTypes.number.isRequired,
    isMobile: PropTypes.bool.isRequired,
    location: PropTypes.object.isRequired,
    navigation: PropTypes.array.isRequired,
    navigationScreens: PropTypes.object.isRequired,
    navigationSteps: PropTypes.array.isRequired,
    onChangeError: PropTypes.func.isRequired,
    onChangeGaId: PropTypes.func.isRequired,
    onChangeRedirectUrl: PropTypes.func.isRequired,
    onChangeWebType: PropTypes.func.isRequired,
    onLoadWebsite: PropTypes.func.isRequired,
    onSetNextPage: PropTypes.func.isRequired,
    onSetScreensMustBeValid: PropTypes.func.isRequired,
    onSetScreensValidateSig: PropTypes.func.isRequired,
    project: PropTypes.string.isRequired,
    redirectUrl: PropTypes.string.isRequired,
    screenIsValid: PropTypes.array.isRequired,
    screenMustBeValid: PropTypes.array.isRequired,
    screenValidateSig: PropTypes.array.isRequired,
    webType: PropTypes.number.isRequired,
    website: PropTypes.string.isRequired,
  }

  constructor(props) {
    super(props)

    this.state = {
      activeIndex: 0,
      personalInfo: true,
      personalInfoRequired: false,
    }

    this.gaInitialized = false,
      this.props.onLoadWebsite(this.props.website)
  }

  componentWillMount = () => {
    I18n.setTexts(csLanguage)
    this.checkDeviceType(this.props)
    this.checkStep(this.props)
    this.handleCheckPersonalInfo(true)

    if (this.props.project === 'SRO') {
      ReactGA.initialize('UA-1832875-32')
      ReactGA.set({ userId: 1514505058.1500528541 })
      this.gaInitialized = true
    } else if (this.props.project === 'POVCOM') {
      ReactGA.initialize('UA-1832875-1')
      ReactGA.set({ userId: 298334686.1500528796 })
      this.gaInitialized = true
    } else if (this.props.project === 'SURI') {
      ReactGA.initialize('UA-1832875-36')
      ReactGA.set({ userId: 994497326.1500528865 })
      this.gaInitialized = true
    }
    ReactGA.ga((tracker) => {
      this.handleOnChangeGaId(tracker.get('clientId'))
    })

    this.props.domexSetDefaultForWebType(this.props.insurance)
    this.props.onChangeWebType(this.props.insurance)

    this.props.domexGetParamsRequest()
  }

  componentWillReceiveProps = (nextProps) => {
    this.checkDeviceType(nextProps)
    this.checkStep(nextProps)
    this.validateAndContinue(nextProps)

    if (nextProps.redirectUrl !== '') {
      nextProps.onChangeRedirectUrl('')
      nextProps.history.push(nextProps.redirectUrl)
    }
  }



  checkDeviceType = (props) => {
    const width = window.innerWidth
    if (!props.isMobile && width < 750) {
      props.onChangeIsMobile(true)
    } else if (props.isMobile && width >= 750) {
      props.onChangeIsMobile(false)
    }
  }

  checkStep = (props) => {
    const index = props.navigationSteps.indexOf(props.location.pathname)
    if (index !== this.state.activeIndex && index !== -1) {
      this.setState({
        activeIndex: props.navigationSteps.indexOf(props.location.pathname)
      })
    } else if (index === -1) {
      this.props.history.push('/')
      // location.hash = '/'
    }
  }

  validateAndContinue = (nextProps) => {
    const toValidate = this.props.screenValidateSig.filter(item => item.validate === true)
    const validated = nextProps.screenValidateSig.filter(item => item.validate === true)
    if (toValidate.length > 0 && validated.length === 0) {
      const valid = nextProps.screenMustBeValid.reduce((acc, mustBeValid, screen) => {
        if (mustBeValid && !nextProps.screenIsValid[screen]) {
          acc = false
        }
        return acc
      }, true)
      if (valid && nextProps.nextPage) {
        window.scrollTo(0, 0)
        if (nextProps.navigationSteps.length - 2 === this.state.activeIndex) {
          if (this.gaInitialized) {
            ReactGA.event({
              category: 'Domex',
              action: 'Send',
              label: this.props.webType === WEB_TYPES.DEFAULT ? 'Nemovitost' :
                this.props.webType === WEB_TYPES.LIABILITY ? 'Odpovědnost' :
                  this.props.webType === WEB_TYPES.HOUSEHOLD ? 'Domácnost' : ''
            })
          }
          nextProps.domexCalculateRequest()
        } else {
          this.props.history.push(nextProps.nextPage)
          // location.hash = nextProps.nextPage
        }
      } else {
        this.props.onSetNextPage('')
      }
    }
  }

  handleContinue = () => {
    const activeRoutes = Object.values(getActiveScreens(
      this.props.navigation,
      this.props.navigationSteps[this.state.activeIndex],
      this.props.navigationSteps
    )).filter((route) => SCREEN_VALIDATE.indexOf(route.screen) !== -1)
    if (this.props.navigationSteps.length - 2 !== this.state.activeIndex ||
      this.props.navigationSteps.length - 2 === this.state.activeIndex && this.state.personalInfo
    ) {
      this.props.onSetScreensMustBeValid(activeRoutes.map(route => (route.screen)))
      this.props.onSetScreensValidateSig(activeRoutes.map(route => (route.screen)), true)
      if (this.props.navigationSteps[this.state.activeIndex + 1]) {
        this.props.onSetNextPage(this.props.navigationSteps[this.state.activeIndex + 1])
      }
    } else {
      this.setState({ personalInfoRequired: true })
    }
  }

  handleBack = () => {
    if (this.props.navigationSteps[this.state.activeIndex - 1]) {
      // location.hash = this.props.navigationSteps[this.state.activeIndex - 1]
      this.props.history.push(this.props.navigationSteps[this.state.activeIndex - 1])
    }
  }

  handleCheckPersonalInfo = (personalInfo) => {
    this.setState({ personalInfo, personalInfoRequired: false })
  }

  handleOnChangeGaId = (gaId) => {
    this.props.onChangeGaId(gaId)
  }

  handleChangeWebType = (webType) => {
    this.props.domexSetDefaultForWebType(webType)
    this.props.onChangeWebType(webType)
  }

  handleHideModal = () => {
    this.props.onChangeError({})
  }

  render() {
    const lastScreen = this.props.navigationSteps.length - 1 === this.state.activeIndex

    return (
      <div className='container'>
        {DEV && <div className='container mb-4'>
          <div className='alert alert-sm alert-with-icon alert-warning m-auto' role='alert'>
            <i className='icon icon-checkmark'></i><span>TEST version: {packageJson.version}, URL: {API_LINK}</span>
          </div>
        </div>}
        {this.props.isMobile && !lastScreen && this.state.activeIndex !== 0 &&
          <NavigationPanel
            step={this.state.activeIndex + 1}
            steps={this.props.navigationSteps}
          />
        }
        {ROUTE_ORDER[this.props.webType].map(screen => {
          const route = ROUTES[screen]
          return (
            <Route
              component={route.component}
              exact={this.props.navigationScreens[route.screen].exact}
              key={route.screen}
              path={this.props.navigationScreens[route.screen].path}
            />
          )
        })}
        {this.props.navigationSteps.length - 2 === this.state.activeIndex &&
          <div className='text-center mt-4'>
            <p className='pt-4'>
              {I18n.translate('general.agreementBeforeLink')}
            <a className="text-success" href={I18n.translate('general.agreementLinkHref')} >{I18n.translate('general.agreementLinkText')}
              </a>{I18n.translate('general.agreementAfterLink')}
            </p>
          </div>
        }
        {!lastScreen &&
          <div className='text-center mt-4 py-2 mb-5'>
            <div className='mt-2'>
              {this.props.isMobile && this.state.activeIndex !== 0 &&
                <DomexButton
                  icon='previous'
                  label={I18n.translate('general.back')}
                  onClick={this.handleBack}
                />
              }
            </div>
            <div className='mt-2'>
              <DomexButton
                icon='next'
                label={this.props.navigationSteps.length - 2 === this.state.activeIndex
                  ? I18n.translate('general.checkPrice')
                  : I18n.translate('general.continue')}
                onClick={this.handleContinue}
                secondary
              />
            </div>
          </div>
        }
        <Modal
          buttonText={I18n.translate('general.ok')}
          onClick={this.handleHideModal}
          text={I18n.translate('general.apiError')}
          visible={!!this.props.error.type}
        />
        <Loader active={this.props.fetching} fullScreen />
      </div>
    )
  }
}

RootScreen.contextTypes = {
  router: PropTypes.object
}

const mapStateToProps = state => {
  const navigation = state.navigation.isMobile ? MOBILE_NAV[state.navigation.webType] : DESKTOP_NAV[state.navigation.webType]
  const navigationSteps = getNavigationSteps(navigation, state.domex.householdActive,
    state.domex.liabilityActive, state.domex.propertyActive)
  const navigationScreens = navigation.reduce((acc, item) => {
    acc[item.screen] = item
    return acc
  }, {})
  return ({
    fetching: state.general.fetching,
    isMobile: state.navigation.isMobile,
    webType: state.navigation.webType,
    nextPage: state.navigation.nextPage,
    navigation,
    navigationSteps,
    navigationScreens,
    screenIsValid: state.general.screenIsValid,
    screenValidateSig: state.general.screenValidateSig,
    screenMustBeValid: state.general.screenMustBeValid,
    error: state.general.error,
    redirectUrl: state.general.redirectUrl,
  })
}

const mapDispatchToProps = {
  onChangeIsMobile: NavigationActions.onChangeIsMobile,
  onLoadWebsite: DomexActions.onLoadWebsite,
  onChangeGaId: DomexActions.onChangeGaId,
  onSetNextPage: NavigationActions.onSetNextPage,
  domexGetParamsRequest: DomexActions.domexGetParamsRequest,
  domexCalculateRequest: DomexActions.domexCalculateRequest,
  onSetScreensValidateSig: GeneralActions.onSetScreensValidateSig,
  onSetScreensMustBeValid: GeneralActions.onSetScreensMustBeValid,
  onChangeWebType: NavigationActions.onChangeWebType,
  domexSetDefaultForWebType: DomexActions.domexSetDefaultForWebType,
  onChangeError: GeneralActions.onChangeError,
  onChangeRedirectUrl: GeneralActions.onChangeRedirectUrl,
}

export default connect(mapStateToProps, mapDispatchToProps)(RootScreen)
